import lottie from 'lottie-web'
import MotionTime from './MotionTime'
import { debounce } from 'underscore'

import instagramIconAnimation from '../../anims/motiontime/snap.json'

export default class InstagramIcon {
    constructor() {
        this.instagramContainer = document.querySelector('.sidebar__instagram')
        this.instagramIconAnimationInstance = lottie.loadAnimation({
            path: instagramIconAnimation,
            loop: false,
            autoplay: false,
            renderer: 'svg',
            container: this.instagramContainer,
        })
        this.instagramIconTimeout = null
        this.motionTime = new MotionTime()

        this.init()
    }

    init() {
        this.touchEventsInit()
        this.mouseEventsInit()
    }

    touchEventsInit() {
        this.instagramContainer.addEventListener(
            'touchstart',
            this.enteringEvent.bind(this)
        )
        this.instagramContainer.addEventListener(
            'touchend',
            this.leavingEvent.bind(this)
        )
    }

    mouseEventsInit() {
        this.debouncedEnteringEvent = debounce(
            this.enteringEvent.bind(this),
            200
        )
        this.instagramContainer.addEventListener(
            'mouseenter',
            this.debouncedEnteringEvent
        )
        this.instagramContainer.addEventListener(
            'mouseleave',
            this.leavingEvent.bind(this)
        )
    }

    enteringEvent() {
        this.instagramContainer.classList.add('buildup')
        if (this.instagramIconAnimationInstance.isPaused) {
            this.instagramIconTimeout = setTimeout(() => {
                this.instagramContainer.classList.remove('buildup')
                this.instagramIconAnimationInstance.setSpeed(1.5)
                this.instagramIconAnimationInstance.playSegments([0, 46], true)
                setTimeout(() => {
                    this.motionTime.unlockItem(5)
                }, 1500)
            }, 2000)
        }
    }

    leavingEvent() {
        clearTimeout(this.instagramIconTimeout)
        this.instagramIconTimeout = null
        this.instagramContainer.classList.remove('buildup')
        if (
            !this.instagramIconAnimationInstance.isPaused ||
            (this.instagramIconAnimationInstance.isPaused &&
                this.instagramIconAnimationInstance.currentFrame == 45)
        ) {
            this.instagramIconAnimationInstance.setSpeed(1)
            this.instagramIconAnimationInstance.playSegments([46, 66], true)
        }
    }

    destroyMouseEvents() {
        this.instagramContainer.removeEventListener(
            'mouseenter',
            this.debouncedEnteringEvent
        )
        this.instagramContainer.removeEventListener(
            'mouseleave',
            this.leavingEvent.bind(this)
        )
    }

    destroyTouchEvents() {
        this.instagramContainer.removeEventListener(
            'touchstart',
            this.enteringEvent.bind(this)
        )
        this.instagramContainer.removeEventListener(
            'touchend',
            this.leavingEvent.bind(this)
        )
    }

    destroyAll() {
        this.destroyMouseEvents()
        this.destroyTouchEvents()
    }
}
